import { pathOr } from 'ramda'
import { createReducer } from 'utils/redux'

const defaultState = {
  geo: {},
  auth: {},
  sockets: {},
  endUser: {},
  isOutbound: false,
  gdpr: {
    needsConsent: true,
    hasConsent: false
  },
  externalId: null,
  instanceId: '',
  id: null,
  sessionStarted: null,
  cookieDomain: '',
  context: {
    page: {},
    timezone: '',
    userAgent: '',
    locale: ''
  },
  visitInformation: {}
}

const receiveSessionHandler = ({ action, draft }) => {
  draft.id = action.payload.session.sessionId
  draft.sessionStarted = action.payload.session.sessionStarted
  draft.campaignRefreshToken = action.payload.session.campaignRefreshToken
  draft.instanceId = action.payload.session.instanceId
}

const receiveContextHandler = ({ action, draft }) => {
  draft.context = action.payload
}

const receiveGeoHandler = ({ action, draft }) => {
  draft.geo = action.payload
}

const receiveAccessTokenHandler = ({ action, draft }) => {
  draft.auth.accessToken = action.payload.accessToken
}

const receiveChatSocketAuthHandler = ({ action, draft }) => {
  draft.auth.socket = {
    ...draft.auth.socket,
    chat: action.payload
  }
}

const receivePresenceSocketAuthHandler = ({ action, draft }) => {
  draft.auth.socket = {
    ...draft.auth.socket,
    visitor_presence: action.payload
  }
}

const receiveSocketHandler = ({ action, draft }) => {
  const cluster = pathOr(null, ['payload', 'cluster'], action)
  if (!cluster) {
    return
  }

  draft.sockets[cluster] = {
    channels: {}
  }
}

const receiveChannelHandler = ({ action, draft }) => {
  const cluster = pathOr(null, ['payload', 'cluster'], action)
  if (!cluster) {
    return
  }

  draft.sockets[cluster].channels[action.payload.key] = action.payload.channel
}

const receiveEndUserHandler = ({ action, draft }) => {
  const isOutbound = !!action.payload.assignedAgentId

  draft.endUser = { ...draft.endUser, ...action.payload.endUser }
  draft.isOutbound = isOutbound

  if (isOutbound) {
    draft.assignedAgentId = action.payload.assignedAgentId
  }
}

const receiveGDPRHandler = ({ action, draft }) => {
  draft.gdpr = { ...draft.gdpr, ...action.payload }
}

const receiveCookieDomainHandler  = ({ action, draft }) => {
  const domain = pathOr(null, ['payload', 'cookieDomain'], action)
  draft.cookieDomain = domain
}

const receiveExternalEmailHandler = ({ action, draft }) => {
  draft.endUser.externalEmail = action.payload
}

const receiveExternalJwtHandler = ({ action, draft }) => {
  draft.endUser.userJwt = action.payload
  draft.endUser.waitForUserJwt = false
}

const waitForExternalJwtHandler = ({ action, draft }) => {
  draft.endUser.waitForUserJwt = true
}

const receiveExternalIdHandler = ({ action, draft }) => {
  draft.externalId = action.payload
}

const receiveUpdatedCampaignRefreshTokenHandler = ({ action, draft }) => {
  draft.campaignRefreshToken = action.payload
}

const identifyLeadHandler = ({ action, draft }) => {
  draft.endUser.email = action.payload
}

const updateInstanceIdHandler = ({ action, draft }) => {
  draft.instanceId = action.payload
}

const receiveVisitInformation = ({ action, draft }) => {
  draft.visitInformation = action.payload
}

const actions = {
  IDENTIFY_LEAD: identifyLeadHandler,
  RECEIVE_GEO: receiveGeoHandler,
  RECEIVE_ACCESS_TOKEN: receiveAccessTokenHandler,
  RECEIVE_CHAT_SOCKET_AUTH: receiveChatSocketAuthHandler,
  RECEIVE_PRESENCE_SOCKET_AUTH: receivePresenceSocketAuthHandler,
  RECEIVE_SOCKET: receiveSocketHandler,
  RECEIVE_CHANNEL: receiveChannelHandler,
  RECEIVE_END_USER: receiveEndUserHandler,
  RECEIVE_EXTERNAL_ID: receiveExternalIdHandler,
  UPDATE_INSTANCE_ID: updateInstanceIdHandler,
  RECEIVE_EXTERNAL_EMAIL: receiveExternalEmailHandler,
  RECEIVE_EXTERNAL_JWT: receiveExternalJwtHandler,
  WAIT_FOR_EXTERNAL_JWT: waitForExternalJwtHandler,
  RECEIVE_GDPR: receiveGDPRHandler,
  RECEIVE_CONTEXT: receiveContextHandler,
  RECEIVE_SESSION: receiveSessionHandler,
  RECEIVE_COOKIE_DOMAIN: receiveCookieDomainHandler,
  RECEIVE_UPDATED_CAMPAIGN_REFRESH_TOKEN: receiveUpdatedCampaignRefreshTokenHandler,
  RECEIVE_VISIT_INFO: receiveVisitInformation
}

const sessionReducer = createReducer(
  defaultState,
  actions
)

export default sessionReducer
